/**
 * Generated runtime TestId mirror for frontend/src/components/identity/IdentitySnapshotView.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const IdentitySnapshotViewTestIds = {
  colAttributeName: "col-attribute-name",
  colAttributeObserved: "col-attribute-observed",
  colAttributeType: "col-attribute-type",
  colAttributeValue: "col-attribute-value",
  colIdentifierPrimary: "col-identifier-primary",
  colIdentifierType: "col-identifier-type",
  colIdentifierValidFrom: "col-identifier-valid-from",
  colIdentifierValue: "col-identifier-value"
} as const;
